import React from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import { CardContainer, LightButton } from "best-common-react";
import AdditionalOptions from "./AdditionalOptions";
import { CompConstants } from "../../constants/CompConstants";
import { ReportConstants } from "../../constants/ReportConstants";
import TimeFrames from "./TimeFrames";

class PlayerComp extends React.Component {
  render() {
    let { trackingHelper } = this.props.rootStore;
    return (
      <React.Fragment>
        <CardContainer>
          <CardContainer.Body>
            <div className="container-fluid">
              <div className="row mx-0">
                <TimeFrames tab={CompConstants.TABS.PLAYER} />
                <AdditionalOptions tab={CompConstants.TABS.PLAYER} />
              </div>
            </div>
          </CardContainer.Body>
          <CardContainer.Footer>
            <div className="header-item-row">
              <LightButton
                onClick={() => {
                  trackingHelper.trackClickAndRunComp(
                    ReportConstants.REPORT_PLAYERPROFILE,
                    "Run Player Profile Report Click"
                  );
                }}
              >
                Run Player Profile Report
              </LightButton>
              <LightButton
                onClick={() => {
                  trackingHelper.trackClickAndRunComp(
                    ReportConstants.REPORT_PLAYERSTATS,
                    "Run Player Statistics Report Click"
                  );
                }}
              >
                Run Player Statistics Report
              </LightButton>
            </div>
          </CardContainer.Footer>
        </CardContainer>
      </React.Fragment>
    );
  }
}

PlayerComp.propTypes = {
  rootStore: PropTypes.object.isRequired
};

export default inject("rootStore")(observer(PlayerComp));
